"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizeText = void 0;
const helpers_1 = require("../../../../../helpers");
const getSizeText = (size) => {
    return `${Number(helpers_1.formatBytes(size, 0, false))} ${helpers_1.getBytesSize(size)}`;
};
exports.getSizeText = getSizeText;
//# sourceMappingURL=getSizeText.js.map